/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9 is the standard for most video and displays, 4:3 is the older television and monitor shape, 21:9 is ultrawide, 3:2 is common for cameras, and 1:1 is a square. Enter any width and height and the tool reduces it to whichever ratio applies.`)
};

const es_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9 es el estándar para la mayoría de videos y pantallas, 4:3 es la forma más antigua de televisión y monitor, 21:9 es ultrawide, 3:2 es común para cámaras, y 1:1 es un cuadrado. Introduce cualquier ancho y alto y la herramienta lo reduce a la relación que corresponda.`)
};

const de_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9 ist der Standard für die meisten Videos und Bildschirme, 4:3 ist das ältere Fernseh- und Monitorformat, 21:9 ist Ultrawide, 3:2 ist bei Kameras verbreitet, und 1:1 ist ein Quadrat. Gib eine beliebige Breite und Höhe ein, und das Tool kürzt sie auf das jeweils zutreffende Verhältnis.`)
};

const nl_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9 is de standaard voor de meeste video's en beeldschermen, 4:3 is de oudere televisie- en monitorbreedte, 21:9 is ultrabreed, 3:2 is gebruikelijk voor camera's en 1:1 is een vierkant. Voer elke breedte en hoogte in en het gereedschap reduceert het tot welke verhouding ook van toepassing is.`)
};

const fr_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9 est la norme pour la plupart des vidéos et des écrans, 4:3 est la forme ancienne de la télévision et du moniteur, 21:9 est ultralarges, 3:2 est courant pour les appareils photo, et 1:1 est un carré. Entrez n'importe quelle largeur et hauteur et l'outil la réduit au rapport qui s'applique.`)
};

const it_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9 è lo standard per la maggior parte dei video e dei display, 4:3 è la forma più vecchia della televisione e del monitor, 21:9 è ultrawide, 3:2 è comune per le fotocamere e 1:1 è un quadrato. Inserisci qualsiasi larghezza e altezza e lo strumento la riduce al rapporto che si applica.`)
};

const pt_br2_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9 é o padrão para a maioria dos vídeos e telas, 4:3 é a forma de televisão e monitor mais antiga, 21:9 é ultrawide, 3:2 é comum para câmeras e 1:1 é um quadrado. Insira qualquer largura e altura e a ferramenta a reduz para qualquer taxa que se aplique.`)
};

const pt_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9 é o padrão para a maioria dos vídeos e ecrãs, 4:3 é a forma antiga de televisão e monitor, 21:9 é ultrawide, 3:2 é comum em câmaras, e 1:1 é um quadrado. Digite qualquer largura e altura e a ferramenta reduz-a para a proporção que se aplica.`)
};

const ja_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9はほとんどのビデオと表示の標準です。4:3は古いテレビとモニターの形、21:9はウルトラワイド、3:2はカメラに一般的で、1:1は正方形です。任意の幅と高さを入力すると、ツールはそれを適用される比率に減らします。`)
};

const zh_ar_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:9是大多数视频和显示器的标准比例,4:3是较旧的电视和显示器形状,21:9是超宽比例,3:2常见于相机,1:1则是正方形。输入任意宽度和高度,工具会将其化简为适用的比例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_faq4_a", locale)
	if (locale === "en") return en_ar_faq4_a(inputs)
	if (locale === "es") return es_ar_faq4_a(inputs)
	if (locale === "de") return de_ar_faq4_a(inputs)
	if (locale === "nl") return nl_ar_faq4_a(inputs)
	if (locale === "fr") return fr_ar_faq4_a(inputs)
	if (locale === "it") return it_ar_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_ar_faq4_a(inputs)
	if (locale === "pt") return pt_ar_faq4_a(inputs)
	if (locale === "ja") return ja_ar_faq4_a(inputs)
	return zh_ar_faq4_a(inputs)
};